import axios from "axios";

import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const getPasDetails = async () => {
  const getPas = `/pas`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3014 + getPas,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getProjectList = async (params) => {
  const getPasProject = `/pas/project`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3014 + getPasProject,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updatePasDetails = async (params, pas_seq) => {
  const updatePas = `/pas/${pas_seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3014 + updatePas,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export { getPasDetails, updatePasDetails, getProjectList };
